module.exports = __webpack_public_path__ + "img/8.82c2e465.png";